export default {
  computed: {
    mKpAlasanPsp() {
      return [
        { text: 'Sekolah didampingi dengan model pendampingan mandiri', value: 1 },
        { text: 'Sekolah tidak masuk prioritas dikunjungi', value: 2 },
        { text: 'Sekolah tidak dikunjungi karena keterbatasan anggaran', value: 3 },
        { text: 'Lainnya', value: 9 },
      ];
    },

    isLaporan2023() {
      const tahunKe = { 1: 3, 2: 2, 3: 1 };
      return +this.pspKpPa['tahun_ke'] >= tahunKe[this.pspKpPa.gelombang];
    },

    schema() {
      if (this.isLaporan2023) {
        return this.schema2023;
      }

      return [
        {
          title: '<strong style="font-size: 18px">Informasi Dasar</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Jenjang Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_jenjang.data.singkat') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Provinsi Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_propinsi.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kab / Kota Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_kota.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Pelaksanaan Kunjungan Lapangan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 0 },
              type: 'VSelect',
              name: 'k_kp_alasan_psp',
              label: 'Alasan Sekolah Tidak Dikunjungi',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.mKpAlasanPsp,
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 0 && +this.form.k_kp_alasan_psp === 9 },
              type: 'VTextarea',
              name: 'alasan_lain',
              label: 'Alasan lainnya (tuliskan alasannya)',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              disabled: this.isPreview,
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Waktu Pelaksanaan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
        {
          hidden: +this.form.is_terlaksana !== 1,
          title: '<strong style="font-size: 18px">Detail Laporan</strong>',
          grid: 12,
          instrumen: [
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'kendala',
              label: 'kendala yang dialami Sekolah',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              autoGrow: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'rencana',
              label: 'Rencana tindak lanjut',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              autoGrow: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'pertanyaan',
              label: 'Pertanyaan yang sering muncul selama kegiatan (terkait kurikulum, BOS dan lain sebagainya)',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              autoGrow: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
            },
          ],
        },
      ];
    },
  },
};
